
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bons-plans-tayara",
      function () {
        return require("private-next-pages/bons-plans-tayara.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bons-plans-tayara"])
      });
    }
  